import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Link } from 'react-router-dom';

const MaritimeTransformation = () => {
  return (
    <>
      <Element
      name="MaritimeTransformation"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-left"
                title = "Energy Sector Transformation"
              />
              <p className="mt-4">Edge AI is redefining how energy producers, distributors, and storage facilities manage assets, predict failures, and respond to external threats in real time. Our energy-focused AI platform empowers rapid, localized decision-making across field devices and control rooms.</p>
              <h6 className="mt-5 mb-4">Transformation Highlights</h6>
              <ul>
                <li>From Scheduled Maintenance → To Predictive Asset Intelligence</li>
                <li>From Reactive Monitoring → To Real-Time Threat Detection</li>
                <li>From Data Overload → To Smart, On-Edge Insights</li>
                <li>From Manual Risk Mapping → To Scalable AI-Driven Surveillance</li>
              </ul>
              <Link className="edu-btn btn-primary" to="/products/m2m-edge-ai">Discover Edge AI Products</Link>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex flex-row flex-wrap align-items-center justify-content-center">
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-blue p-4">
                    <h5 className="mtsc-heading mb-0">
                      40%
                    </h5>
                    <small>Reduction in Unplanned Downtime</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-green p-4">
                    <h5 className="mtsc-heading mb-0">
                      3X
                    </h5>
                    <small>Faster Anomaly Detection</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-purple p-4">
                    <h5 className="mtsc-heading mb-0">
                      35%
                    </h5>
                    <small>Improvement in Risk Forecasting</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-orange p-4">
                    <h5 className="mtsc-heading mb-0">
                      20%
                    </h5>
                    <small>Reduction in Operational Disruptions</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default MaritimeTransformation;